export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const shouldRecaptchaExist: boolean = !!RECAPTCHA_SITE_KEY;
